var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0FBBE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.9908 33.5H20.0108C16.5008 33.5 15.7408 31.49 16.0308 29.03L16.9308 21.53C17.1608 19.59 17.5008 18 20.9008 18H28.1008C31.5008 18 31.8408 19.59 32.0708 21.53L32.8208 27.78L32.9708 29.03C32.9808 29.11 32.9908 29.19 33.0008 29.27C33.2108 31.62 32.3908 33.5 28.9908 33.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20.25C28.09 20.25 27.75 19.91 27.75 19.5V16C27.75 14.92 27.08 14.25 26 14.25H23C21.92 14.25 21.25 14.92 21.25 16V19.5C21.25 19.91 20.91 20.25 20.5 20.25C20.09 20.25 19.75 19.91 19.75 19.5V16C19.75 14.09 21.09 12.75 23 12.75H26C27.91 12.75 29.25 14.09 29.25 16V19.5C29.25 19.91 28.91 20.25 28.5 20.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 29.2703C32.97 29.2803 32.94 29.2803 32.91 29.2803H20.5C20.09 29.2803 19.75 28.9403 19.75 28.5303C19.75 28.1103 20.09 27.7803 20.5 27.7803H32.82L32.97 29.0303C32.98 29.1103 32.99 29.1903 33 29.2703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.6464d9fff02d4e721c6db57db35761dd.svg";
export { ForwardRef as ReactComponent };